export default (fn) => {
  const n = fn.split(' ');

  let it = '';
  let i = 0;
  while (i < n.length) {
    it += n[i][0];
    i++;
  }

  return it.toUpperCase();
};
